import { create } from '@bufbuild/protobuf'
import { t } from 'i18next'

import {
  StatusLabel,
  StatusLabelSchema,
  StatusLabel_Status,
} from '@enechain/eposition-proto/bfftypes/v1/label_pb'
import { OrganizationOptionCategory } from '@enechain/eposition-ui'
import { ECLEAR_OPTION_CATEGORY } from '@enechain/eposition-ui/src/models/eclearOption'

import { ResultSimulationForOption1Model } from '~/pages/Simulation/models/SimulationResultModel/ResultSimulationForOption1Model'

export type ResultAvailableDealSimulationForOption1Models = {
  allowDealStatus: StatusLabel
  collateralAmount: string
  totalCreditAmount: string
  details: ResultSimulationForOption1Model[]
  type: OrganizationOptionCategory
}

export function convertAvailableDealSimulationForOption1Models(
  models: ResultSimulationForOption1Model[],
): ResultAvailableDealSimulationForOption1Models {
  const allowDealStatus = models.every((model) => model.allowDeal)
    ? create(StatusLabelSchema, {
        status: StatusLabel_Status.POSITIVE,
        label: t('domain:model.deal.deal_available.available'),
      })
    : create(StatusLabelSchema, {
        status: StatusLabel_Status.NEGATIVE,
        label: t('domain:model.deal.deal_available.unavailable'),
      })
  return {
    allowDealStatus,
    collateralAmount: models[0].collateralAmount ?? '-',
    totalCreditAmount: models[0].totalCreditAmount ?? '-',
    details: models,
    type: ECLEAR_OPTION_CATEGORY.OPTION_1,
  }
}
